// GET https://api.swiftaid.co.uk/donor/v1-dev/me

export default {
  landingPage: 100,
  dashboardSeen: true,
  dashboardFirstSeenAt: '2024-06-01T09:00:00.000Z',
  emailAddress: 'bob.fossil@example.com',
  details: {
    firstname: 'Bob',
    lastname: 'Fossil',
    addressLine1: '12 Elm Close',
    addressLine2: '',
    city: 'London',
    postcode: 'SW4 8NR',
    county: '',
    country: 'United Kingdom',
  },
}
